"use client";

import { useRouter } from "next/navigation";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { CustomNavigationClient, msalInstance } from "@/lib/auth/msal";

import { UiProvider } from "@/context/util/ui";

import { DynamicMsalProvider } from "@/components/msal/providers";
import { PageLayout } from "@/components/ui";

import theme from "@/styles/theme";

export function GlobalProviders({ children }: { children: React.ReactNode }) {
  const router = useRouter();

  const navigationClient = new CustomNavigationClient(router);
  msalInstance.setNavigationClient(navigationClient);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DynamicMsalProvider>
        <UiProvider>
          <PageLayout>{children}</PageLayout>
        </UiProvider>
      </DynamicMsalProvider>
    </ThemeProvider>
  );
}
